<template>
  <div class="helloSvg-wrapper" @mousemove="bodyDragMove">
    <div class="header">
      <div class="logo">
        <img src="../../../static/images/logoBig.png" />
      </div>
    </div>
    <div class="content">
      <div class="hero_container">
        <div class="hero_logoAnimated" style="margin-top: 120px">
          <img
            class="image-animation"
            style="width: 440px; margin: 0 auto; margin-left: -94px"
            src="../../../static/images/wenziBig.png"
          />
        </div>

        <svg
          class="hero_fallingLines__iA0dJ"
          width="22"
          height="228"
          viewBox="0 0 22 228"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="
            translate: none;
            rotate: none;
            scale: none;
            opacity: 1;
            transform: translate(0px, 0px);
            transform-origin: 50% 0%;
            margin-top: 300px;
          "
        >
          <path
            opacity=".15"
            stroke="url(#home-hero-falling-lines-a)"
            stroke-width="6"
            d="M11 228V-1.3e-7"
          ></path>
          <path
            id="glow-1"
            opacity=".8"
            stroke="url(#home-hero-falling-lines-b)"
            stroke-width="6"
            d="M11 228V-1.3e-7"
            class="hero_glow__TNALL"
            :style="{ opacity: opacity1 }"
          ></path>
          <path
            opacity=".15"
            stroke="url(#home-hero-falling-lines-c)"
            stroke-width="6"
            d="m3 216 .00001-201.4144"
          ></path>
          <path
            id="glow-2"
            opacity=".8"
            stroke="url(#home-hero-falling-lines-d)"
            stroke-width="6"
            d="m3 216 .00001-201.4144"
            class="hero_glow__TNALL"
            :style="{ opacity: opacity2 }"
          ></path>
          <path
            opacity=".15"
            stroke="url(#home-hero-falling-lines-e)"
            stroke-width="6"
            d="M19 216V14.5856"
          ></path>
          <path
            id="glow-3"
            opacity=".8"
            stroke="url(#home-hero-falling-lines-f)"
            stroke-width="6"
            d="M19 216V14.5856"
            class="hero_glow__TNALL"
            :style="{ opacity: opacity3 }"
          ></path>
          <path
            stroke="url(#home-hero-falling-lines-g)"
            stroke-width="2"
            d="M11 228V-4e-8"
          ></path>
          <path
            stroke="url(#home-hero-falling-lines-h)"
            stroke-width="2"
            d="m3 216 .00001-201.4144"
          ></path>
          <path
            stroke="url(#home-hero-falling-lines-i)"
            stroke-width="2"
            d="M19 216V14.5856"
          ></path>
          <defs>
            <linearGradient
              id="home-hero-falling-lines-a"
              x1="14.0021"
              y1="1e-8"
              x2="14.0016"
              y2="228"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
              <stop offset=".489583" stop-color="#0D33F2"></stop>
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-b"
              x1="14.0021"
              y1="1e-8"
              x2="14.0016"
              y2="228"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                :offset="nowCount1"
                stop-color="#0D33F2"
                stop-opacity="0"
              ></stop>
              <stop :offset="nowCount2" stop-color="#0D33F2"></stop>
              <stop
                :offset="nowCount3"
                stop-color="#0D33F2"
                stop-opacity="0"
              ></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-c"
              x1="6.00215"
              y1="14.5856"
              x2="6.00169"
              y2="216"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0D33F2" stop-opacity="0"></stop>
              <stop offset=".489583" stop-color="#0D33F2"></stop>
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-d"
              x1="6.00215"
              y1="14.5856"
              x2="6.00169"
              y2="216"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                :offset="nowCount1"
                stop-color="#0D33F2"
                stop-opacity="0"
              ></stop>
              <stop :offset="nowCount2" stop-color="#0D33F2"></stop>
              <stop
                :offset="nowCount3"
                stop-color="#0D33F2"
                stop-opacity="0"
              ></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-e"
              x1="22.0021"
              y1="14.5856"
              x2="22.0017"
              y2="216"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0D33F2" stop-opacity="0"></stop>
              <stop offset=".489583" stop-color="#0D33F2"></stop>
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-f"
              x1="22.0021"
              y1="14.5856"
              x2="22.0017"
              y2="216"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                :offset="nowCount1"
                stop-color="#0D33F2"
                stop-opacity="0"
              ></stop>
              <stop :offset="nowCount2" stop-color="#0D33F2"></stop>
              <stop
                :offset="nowCount3"
                stop-color="#0D33F2"
                stop-opacity="0"
              ></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-g"
              x1="12.0021"
              y1="1e-8"
              x2="12.0016"
              y2="228"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0D33F2" stop-opacity="0"></stop>
              <stop offset=".489583" stop-color="#0D33F2"></stop>
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-h"
              x1="4.00215"
              y1="14.5856"
              x2="4.00169"
              y2="216"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0D33F2" stop-opacity="0"></stop>
              <stop offset=".489583" stop-color="#0D33F2"></stop>
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
            </linearGradient>
            <linearGradient
              id="home-hero-falling-lines-i"
              x1="20.0021"
              y1="14.5856"
              x2="20.0017"
              y2="216"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#0D33F2" stop-opacity="0"></stop>
              <stop offset=".489583" stop-color="#0D33F2"></stop>
              <stop offset="1" stop-color="#0D33F2" stop-opacity="0"></stop>
            </linearGradient>
          </defs>
        </svg>
        <div class="hero_joinCtaWrapper__Zb21k" style="text-align: center">
          <!-- <button
            class="cta_cta__pjYag cta_colored__vhVrW cta_xl__fgT4k"
            @click.stop="internalTest"
          >
            <div class="cta_content__zyHoI">立即体验</div>
          </button>
          <p class="experience">
            <span>如您已通过审核，点这里</span>
            <span @click.stop="login">立即登录</span>
          </p> -->
          <button
            class="cta_cta__pjYag cta_colored__vhVrW cta_xl__fgT4k"
            @click.stop="login"
          >
            <div class="cta_content__zyHoI">立即体验</div>
          </button>
          <!-- <p class="application" v-else>
						<img src="../../../static/images/success.png" />
						<span>您已在等待体验中，加入成功将以短信通知</span>
					</p>
					<p class="experience">
						<span>已通过审核的用户请</span>
						<span @click.stop="login">登录体验</span>
					</p> -->
        </div>
      </div>
    </div>
    <div class="footer"></div>
    <el-dialog v-model="loginFlag" width="86%" align-center>
      <div class="login-content">
        <div class="top">
          <img src="../../../static/images/neicebanBig.png" />
        </div>
        <div class="center">
          <div class="line">
            <span class="nam">短信登录</span>
            <span class="border"></span>
          </div>
          <div class="loginInfo">
            <el-form
              ref="loginRuleForm"
              :model="loginInfo"
              :rules="loginRules"
              label-width="120px"
              class="demo-ruleForm"
            >
              <div class="line phone loginLine">
                <el-form-item prop="phone">
                  <el-input
                    v-model="loginInfo.phone"
                    placeholder="请填写您的手机号"
                  />
                </el-form-item>
              </div>
              <div class="line pwd loginLine">
                <el-form-item prop="code">
                  <el-input
                    maxlength="8"
                    class="yzm"
                    v-model="loginInfo.code"
                    placeholder="短信验证码"
                    @keyup.enter="loginSubmitForm"
                  />
                  <el-button
                    class="btn"
                    plain
                    :style="{ color: loginCodeInfo.getCodeBtnColor }"
                    @click="getLoginCode"
                    >{{ loginCodeInfo.getCodeText }}</el-button
                  >
                </el-form-item>
              </div>
              <div class="line loginLine checked">
                <el-checkbox v-model="loginChecked" />
                <span class="span">
                  阅读并同意
                  <span class="color" @click="userAgreement">《用户协议》</span
                  >和
                  <span class="color" @click="privacyPolicy">《隐私政策》</span>
                </span>
              </div>
              <div class="line login-line">
                <el-form-item>
                  <el-button @click="loginSubmitForm">立即登录</el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-model="internalTestFlag" width="86%" align-center>
      <div class="login-content">
        <div class="top">
          <img src="../../../static/images/neicebanBig.png" />
        </div>
        <div class="center">
          <el-form
            ref="registerRuleForm"
            :model="internalTestInfo"
            :rules="registerRules"
            label-width="120px"
            class="demo-ruleForm"
          >
            <div class="line">
              <el-form-item label="您的姓名" prop="name">
                <el-input
                  v-model="internalTestInfo.name"
                  placeholder="请填写您的姓名"
                />
              </el-form-item>
            </div>
            <div class="line">
              <el-form-item label="您的手机号" prop="phone">
                <el-input
                  v-model="internalTestInfo.phone"
                  placeholder="请填写您的手机号"
                />
              </el-form-item>
            </div>
            <div class="line pwd code">
              <el-form-item label="短信验证码" prop="code">
                <el-input
                  maxlength="6"
                  class="yzm"
                  v-model="internalTestInfo.code"
                  placeholder="请输入短信验证码"
                />
                <span
                  class="getCode"
                  :style="{ color: registerCodeInfo.getCodeBtnColor }"
                  @click="getCode"
                >
                  {{ registerCodeInfo.getCodeText }}
                </span>
              </el-form-item>
            </div>
            <div class="line pwd">
              <el-form-item label="您的身份（单选）" prop="role">
                <el-radio-group v-model="internalTestInfo.role" class="ml-4">
                  <el-radio label="1">医疗行业从业者</el-radio>
                  <el-radio label="2">非医疗行业人员</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="line">
              <el-form-item label="所在机构" prop="hospital">
                <el-input
                  v-model="internalTestInfo.hospital"
                  placeholder="请填写真实医疗机构/单位名称"
                />
              </el-form-item>
            </div>
            <div class="line" style="display: none">
              <el-form-item label="从事的岗位" prop="title">
                <!-- <el-input v-model="internalTestInfo.title" placeholder="请选择您从事的岗位" /> -->
                <el-select
                  style="width: 100%"
                  v-model="internalTestInfo.title"
                  class="m-2"
                  placeholder="请选择您从事的岗位"
                >
                  <el-option
                    v-for="item in titleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="line checkbox" style="display: none">
              <el-form-item
                label="您希望如何使用大经中医岐黄问道大模型？（多选）"
                prop="title"
              >
                <el-checkbox-group v-model="goalArr" text-color="#999999">
                  <el-checkbox label="在线问诊" />
                  <el-checkbox label="在线学习" />
                  <el-checkbox label="闲聊" />
                  <el-checkbox label="其他" />
                </el-checkbox-group>
              </el-form-item>
            </div>
            <!-- <div class="line checked">
							<el-checkbox v-model="registerChecked" />
							<span>
								阅读并同意《用户服务》和《隐私协议》,手机号将自动注册
							</span>
						</div> -->
            <div class="line login-line">
              <el-form-item>
                <el-button @click="submitForm">提交申请</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-model="userAgreementFlag" width="92%" align-center>
      <div class="login-content login-content2">
        <iframe
          class="network_show"
          name="content_frame"
          :src="globalImgPath + '/docs/userAgreement.html'"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </el-dialog>
    <el-dialog v-model="privacyPolicyFlag" width="92%" align-center>
      <div class="login-content login-content2">
        <iframe
          class="network_show"
          name="content_frame"
          :src="globalImgPath + '/docs/privacyPolicy.html'"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  toRefs,
  defineComponent,
  getCurrentInstance,
  onMounted,
} from "vue";

import { useRouter } from "vue-router";

import { ElMessage } from "element-plus";

import { useStore } from "vuex"; // 引入useStore 方法

// 手机号验证规则
const validatePhon = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入手机号码"));
  } else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(value)) {
    callback(new Error("请输入正确的手机号码"));
  } else {
    callback();
  }
};

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore(); // 该方法用于返回store 实例
    const uniHttp = getCurrentInstance().appContext.config.globalProperties;
    const globalImgPath = uniHttp.globalImgPath;
    const registerRuleForm = ref(null); // 注册form表单
    const loginRuleForm = ref(null); // 登录form表单
    const data = reactive({
      role: 2,
      opacity1: 0,
      addFlag1: true,
      reduceFlag1: false,
      opacity2: 0,
      addFlag2: true,
      reduceFlag2: false,
      opacity3: 0,
      addFlag3: true,
      reduceFlag3: false,
      x: 0,
      y: 0,
      offset1: 0.557,
      nowCount1: 0,
      offset2: 0.77,
      nowCount2: 0,
      offset3: 1,
      nowCount3: 0,
      originX: 0,
      originY: 0,
      svgOffset1: 0.87,
      svgOffset2: 0.94,
      svgOffset3: 1,
      svgnOwCount1: 0,
      svgnOwCount2: 0,
      svgnOwCount3: 0,
      svgnOwCount4: 0,
      svgnOwCount5: 0,
      svgnOwCount6: 0,
      svgnOwCount7: 7,
      svgnOwCount8: 8,
      svgnOwCount9: 9,
      loginFlag: false, //登录flag
      loginInfo: {
        phone: "",
        code: "",
      },
      loginRules: {
        phone: [
          {
            required: true,
            validator: validatePhon,
            trigger: "blur",
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
      },
      loginCodeInfo: {
        holdTime: 60,
        getCodeText: "获取验证码",
        getCodeBtnColor: "#333",
        getCodeisWaiting: false,
        codeTimer: null,
      },
      loginChecked: true,
      //注册信息
      registerChecked: true,
      internalTestFlag: false, //内测申请
      goalArr: [],
      internalTestInfo: {
        name: "",
        phone: "",
        role: "", //1：医疗行业从业者 2.非医疗行业从业者 ,
        hospital: "",
        title: "",
        goal: "",
      },
      registerRules: {
        name: [
          {
            required: true,
            message: "请输入您的姓名",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePhon,
            trigger: "blur",
          },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入短信验证码",
            trigger: "blur",
          },
        ],
      },
      registerCodeInfo: {
        holdTime: 60,
        getCodeText: "获取验证码",
        getCodeBtnColor: "#001D7F",
        getCodeisWaiting: false,
        codeTimer: null,
      },
      titleOptions: [
        {
          value: "医务人员",
          label: "医务人员",
        },
        {
          value: "医疗行业从业者",
          label: "医疗行业从业者",
        },
        {
          value: "在校医学生",
          label: "在校医学生",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      applicationFlag: true,
      userAgreementFlag: false,
      privacyPolicyFlag: false,
      bodyX: 484,
      bodyY: 310,
    });

    //切换Offset
    const changeOffset = () => {
      let step = data.offset1 / 8;
      let count1 = 0;
      let count2 = 0.22;
      let count3 = 0.23;
      let timer = null;
      timer = setInterval(() => {
        if (count2 < data.offset2) {
          count1 = count1 + step;
          count2 = count1 + step;
          count3 = count2 + step;
          data.nowCount1 = count1;
          data.nowCount2 = count2;
          data.nowCount3 = count3;
        } else {
          count1 = 0;
          data.nowCount1 = 0.55;
          data.nowCount2 = 0.77;
          data.nowCount3 = 1;
          clearInterval(timer);
          timer = null;
        }
      }, 125);
    };

    //切换svgOffset
    const changeSvgOffset = () => {
      let step = data.svgOffset1 / 16;
      let count1 = 0;
      let count2 = 0.1;
      let count3 = 0.15;
      let timer = null;
      timer = setInterval(() => {
        if (count2 < data.svgOffset2) {
          count1 = count1 + step;
          count2 = count1 + step;
          count3 = count2 + step;
          data.svgnOwCount1 = count1;
          data.svgnOwCount2 = count2;
          data.svgnOwCount3 = count3;
        } else {
          count1 = 0;
          data.svgnOwCount1 = 0.87;
          data.svgnOwCount2 = 0.94;
          data.svgnOwCount3 = 1;
          clearInterval(timer);
          timer = null;
        }
      }, 125);
    };

    //切换svgOffset
    const changeSvgOffset1 = () => {
      let step = data.svgOffset1 / 16;
      let count1 = 0;
      let count2 = 0.1;
      let count3 = 0.15;
      let timer = null;
      timer = setInterval(() => {
        if (count2 < data.svgOffset2) {
          count1 = count1 + step;
          count2 = count1 + step;
          count3 = count2 + step;
          data.svgnOwCount4 = count1;
          data.svgnOwCount5 = count2;
          data.svgnOwCount6 = count3;
        } else {
          count1 = 0;
          data.svgnOwCount4 = 0.87;
          data.svgnOwCount5 = 0.94;
          data.svgnOwCount6 = 1;
          clearInterval(timer);
          timer = null;
        }
      }, 125);
    };

    //切换svgOffset
    const changeSvgOffset2 = () => {
      let step = data.svgOffset1 / 16;
      let count1 = 0;
      let count2 = 0.1;
      let count3 = 0.15;
      let timer = null;
      timer = setInterval(() => {
        if (count2 < data.svgOffset2) {
          count1 = count1 + step;
          count2 = count1 + step;
          count3 = count2 + step;
          data.svgnOwCount7 = count1;
          data.svgnOwCount8 = count2;
          data.svgnOwCount9 = count3;
        } else {
          count1 = 0;
          data.svgnOwCount7 = 0.87;
          data.svgnOwCount8 = 0.94;
          data.svgnOwCount9 = 1;
          clearInterval(timer);
          timer = null;
        }
      }, 125);
    };

    const handleDragMove = (e) => {
      data.originX = e.offsetX;
      data.originY = e.offsetY;
    };

    //切换
    const changeOpaticy1 = () => {
      let timer1 = null;
      timer1 = setInterval(() => {
        if (data.reduceFlag1) {
          data.opacity1 -= 0.2;
          if (data.opacity1.toFixed(1) < 0) {
            data.opacity1 = 0;
            clearInterval(timer1);
            timer1 = null;
            data.reduceFlag1 = false;
            data.addFlag1 = true;
          }
        }
        if (data.addFlag1 && timer1) {
          data.opacity1 += 0.2;
          if (data.opacity1 >= 1) {
            data.opacity1 = 1;
            data.reduceFlag1 = true;
            data.addFlag1 = false;
          }
        }
      }, 200);
    };

    //切换
    const changeOpaticy2 = () => {
      let timer2 = null;
      timer2 = setInterval(() => {
        if (data.reduceFlag2) {
          data.opacity2 -= 0.2;
          if (data.opacity2.toFixed(1) < 0) {
            data.opacity2 = 0;
            clearInterval(timer2);
            timer2 = null;
            data.reduceFlag2 = false;
            data.addFlag2 = true;
          }
        }
        if (data.addFlag2 && timer2) {
          data.opacity2 += 0.2;
          if (data.opacity2 >= 1) {
            data.opacity2 = 1;
            data.reduceFlag2 = true;
            data.addFlag2 = false;
          }
        }
      }, 200);
    };

    //切换
    const changeOpaticy3 = () => {
      let timer3 = null;
      timer3 = setInterval(() => {
        if (data.reduceFlag3) {
          data.opacity3 -= 0.2;
          if (data.opacity3.toFixed(1) < 0) {
            data.opacity3 = 0;
            clearInterval(timer3);
            timer3 = null;
            data.reduceFlag3 = false;
            data.addFlag3 = true;
          }
        }
        if (data.addFlag3 && timer3) {
          data.opacity3 += 0.2;
          if (data.opacity3 >= 1) {
            data.opacity3 = 1;
            data.reduceFlag3 = true;
            data.addFlag3 = false;
          }
        }
      }, 200);
    };

    //登录
    const login = () => {
      const loginFlag = window.localStorage.getItem("loginFlag");
      const GptMToken = window.localStorage.getItem("GptMToken");
      if (loginFlag && GptMToken) {
        router.push({
          path: "/GptChartIndex/GptChartIndex",
        });
      } else {
        router.push({
          path: "/GptLogin/GptLogin",
        });
      }

      /* data.loginFlag = true
				data.registerCodeInfo = {
					holdTime: 60,
					getCodeText: '获取验证码',
					getCodeBtnColor: '#001D7F',
					getCodeisWaiting: false,
					codeTimer: null,
				}
				nextTick(() => {
					loginRuleForm.value.resetFields()
				}); */
    };

    //内测申请
    const internalTest = () => {
      router.push({
        path: "/ApplyBeta/ApplyBeta",
      });
      /* data.loginCodeInfo = {
					holdTime: 60,
					getCodeText: '获取验证码',
					getCodeBtnColor: '#001D7F',
					getCodeisWaiting: false,
					codeTimer: null,
				}
				nextTick(() => {
					registerRuleForm.value.resetFields()
				}); */
    };

    //注册立即登录
    const submitForm = () => {
      registerRuleForm.value.validate((valid) => {
        if (valid) {
          doctorSmsVerify(data.internalTestInfo, "register");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    //登录立即登录
    const loginSubmitForm = () => {
      if (!data.loginChecked) {
        ElMessage.error({
          message: "请勾选阅读并同意《用户服务》和《隐私协议》",
        });
      } else {
        loginRuleForm.value.validate((valid) => {
          if (valid) {
            doctorSmsVerify(data.loginInfo, "login");
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    };

    //获取验证码
    const getCode = () => {
      if (data.registerCodeInfo.getCodeisWaiting) {
        return false;
      }
      registerRuleForm.value.validateField("phone", (phoneValid) => {
        if (!phoneValid) {
          return false;
        } else {
          data.registerCodeInfo.getCodeisWaiting = true;

          getDoctorSms(data.internalTestInfo.phone, "1");
        }
      });
    };

    //定时器
    const setTimer = (registerCodeInfo) => {
      registerCodeInfo.getCodeText = "重新获取(60)";
      registerCodeInfo.codeTimer = setInterval(() => {
        if (registerCodeInfo.holdTime <= 0) {
          registerCodeInfo.getCodeisWaiting = false;
          registerCodeInfo.getCodeText = "获取验证码";
          registerCodeInfo.getCodeBtnColor = "#001D7F";
          clearInterval(registerCodeInfo.codeTimer); //清除该函数
          return; //返回前面
        }
        registerCodeInfo.getCodeBtnColor = "#333";
        registerCodeInfo.getCodeText =
          "重新获取(" + registerCodeInfo.holdTime + ")";
        registerCodeInfo.holdTime--;
      }, 1000);
    };

    //获取验证码
    const getDoctorSms = (phone, type) => {
      uniHttp
        .$applicationJson("business/user/sms", {
          phone: phone,
          type: type,
        })
        .then((res) => {
          if (res.data.code == 200) {
            ElMessage({
              showClose: true,
              message: "验证码已发送",
              type: "success",
            });
            if (type == "1") {
              setTimer(data.registerCodeInfo); //调用定时器方法
              data.registerCodeInfo.getCodeisWaiting = false;
            }
            if (type == "4") {
              setTimer(data.loginCodeInfo); //调用定时器方法
              data.loginCodeInfo.getCodeisWaiting = false;
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
            if (type == "1") {
              data.registerCodeInfo.getCodeisWaiting = false;
            }
            if (type == "4") {
              data.loginCodeInfo.getCodeisWaiting = false;
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
          if (type == "1") {
            setTimer(data.registerCodeInfo); //调用定时器方法
            data.registerCodeInfo.getCodeisWaiting = false;
          }
          if (type == "4") {
            setTimer(data.loginCodeInfo); //调用定时器方法
            data.loginCodeInfo.getCodeisWaiting = false;
          }
        });
    };

    //验证码验证
    const doctorSmsVerify = (info, type) => {
      uniHttp
        .$applicationJson("business/user/sms/verify", {
          phone: info.phone,
          code: info.code,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (type == "register") {
              register();
            }
            if (type == "login") {
              loginSubmit();
            }
          } else {
            ElMessage({
              showClose: true,
              message: "请输入正确的验证码",
              type: "error",
            });
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //注册
    const register = () => {
      if (data.goalArr.length > 0) {
        data.internalTestInfo.goal = data.goalArr.join(",");
      }
      uniHttp
        .$applicationJson("business/user/register", {
          name: data.internalTestInfo.name,
          phone: data.internalTestInfo.phone,
          role: data.internalTestInfo.role,
          hospital: data.internalTestInfo.hospital,
          title: data.internalTestInfo.title,
          goal: data.internalTestInfo.goal,
        })
        .then((res) => {
          if (res.data.code == 0) {
            data.internalTestFlag = false;
            data.applicationFlag = false;
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //登录获取验证码
    const getLoginCode = () => {
      if (data.loginCodeInfo.getCodeisWaiting) {
        return false;
      }
      loginRuleForm.value.validateField("phone", (phoneValid) => {
        if (!phoneValid) {
          return false;
        } else {
          data.loginCodeInfo.getCodeisWaiting = true;
          getDoctorSms(data.loginInfo.phone, "4");
        }
      });
    };

    //登录
    const loginSubmit = () => {
      uniHttp
        .$applicationJson("business/user/login", {
          phone: data.loginInfo.phone,
          code: data.loginInfo.code,
        })
        .then((res) => {
          if (res.data.code == 0) {
            window.localStorage.removeItem("role");
            data.loginFlag = false;
            window.localStorage.setItem("GptMToken", res.data.data.token);
            window.localStorage.setItem("userId", res.data.data.id);
            window.localStorage.setItem("role", 0);
            window.localStorage.setItem("gptLogin", 2); //默认只显示知病单轮
            window.localStorage.setItem(
              "userInfo",
              JSON.stringify(res.data.data)
            );
            store.commit("changeLogin", {
              GptMToken: res.data.data.token,
            });
            if (res.data.data.role == 0) {
              router.push({
                path: "/managementHome/managementHome",
              });
            } else {
              goHome();
            }
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };

    //路由跳转
    const goHome = () => {
      window.localStorage.removeItem("conversationDetail");
      conversationAdd("", "", "");
    };
    //新增标题
    const conversationAdd = (name, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/add", {
          role: 0,
          illName: illName,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let conversationId = res.data.data.conversationId;
            conversationEdit(name, conversationId, question, illName);
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };
    //编辑标题
    const conversationEdit = (name, conversationId, question, illName) => {
      uniHttp
        .$applicationJson("business/conversation/edit", {
          conversationId: conversationId,
          title: name,
        })
        .then((res) => {
          if (res.data.code == 0) {
            window.localStorage.setItem("preQuestion", "");
            router.push({
              path: "/GptChart/GptChart",
              query: {
                conversationId: conversationId,
                question: question,
                illName: illName,
                role: 0,
              },
            });
          } else {
            if (res.status != 203 && res.status != 205) {
              ElMessage({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    };
    //用户协议
    const userAgreement = () => {
      data.userAgreementFlag = true;
    };

    //隐私政策
    const privacyPolicy = () => {
      data.privacyPolicyFlag = true;
    };

    const bodyDragMove = (e) => {
      data.bodyX = e.offsetX;
      data.bodyY = e.offsetY;
    };

    onMounted(() => {
      setInterval(() => {
        changeOffset();
      }, 2000);
      setInterval(() => {
        changeSvgOffset();
      }, 4000);
      setTimeout(() => {
        setInterval(() => {
          changeSvgOffset1();
        }, 4000);
      }, 1000);
      setTimeout(() => {
        data.bgShowFlag = true;
        setInterval(() => {
          changeSvgOffset2();
        }, 4000);
      }, 2000);
      setInterval(() => {
        changeOpaticy3();
      }, 2000);
      setInterval(() => {
        changeOpaticy2();
      }, 2500);
      setInterval(() => {
        changeOpaticy1();
      }, 3000);
    });

    return {
      registerRuleForm,
      loginRuleForm,
      uniHttp,
      globalImgPath,
      ...toRefs(data),
      changeOffset,
      changeSvgOffset,
      changeSvgOffset1,
      changeSvgOffset2,
      handleDragMove,
      login,
      internalTest,
      register,
      submitForm,
      getCode,
      doctorSmsVerify,
      loginSubmit,
      getLoginCode,
      loginSubmitForm,
      goHome,
      userAgreement,
      privacyPolicy,
      bodyDragMove,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.helloSvg-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url("/src/assets/mobile_bg.png") no-repeat center;
  background-size: 100%;
  overflow-x: hidden;
}
.hero_mask {
  opacity: 0.85 !important;
}

@media (hover: hover) and (pointer: fine) {
  .helloSvg-wrapper .hero_maskOne {
    --bg: var(--black-2);
    --radius: 270px;
    --x: 0px;
    --y: 70px;
    opacity: 1;
    display: block;
    transition: opacity 0.2s ease-in-out;
    background-color: var(--bg);
    -webkit-mask-image: radial-gradient(
      circle var(--radius) at var(--x) var(--y),
      transparent,
      var(--bg)
    );
    mask-image: radial-gradient(
      circle var(--radius) at var(--x) var(--y),
      transparent,
      var(--bg)
    );
    pointer-events: none;
    position: absolute;
    will-change: webkitmaskimage, opacity;
    backface-visibility: hidden;
    inset: 0;
    backdrop-filter: blur(100px);
  }
}

.header {
  height: 58px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background-color: #070607;
  position: absolute;
  top: 10px;
  z-index: 9;

  .logo {
    height: 58px;
    width: 160px;
    margin: 0 auto;
    float: left;
    overflow: hidden;
    margin-left: 30px;
    img {
      float: left;
      width: 120px;
      margin-top: 10px;
    }
  }

  .login {
    float: right;
    height: 58px;
    line-height: 58px;

    .login-div {
      width: 120px;
      height: 36px;
      text-align: center;
      border-radius: 5px;
      line-height: 36px;
      color: #fff;
      margin-top: 11px;
      background: #3a3a3a;
      font-size: 16px;
      margin-right: 30px;
      cursor: pointer;
    }
  }
}

@media screen and (max-width: 1920px) and (min-width: 1680px) {
  .header {
    height: 68px;
    .logo {
      img {
        width: 140px;
      }
    }
    .login {
      height: 68px;
      line-height: 68px;
      .login-div {
        height: 42px;
        line-height: 42px;
        width: 140px;
      }
    }
  }
}

@media screen and (max-width: 1440px) and (min-width: 0px) {
  .bigSvg {
    width: 1000px;
    margin-top: -52px !important;
    display: none;
  }
}

@media screen and (max-width: 1680px) and (min-width: 1440px) {
  .bigSvg {
    width: 1200px;
    display: none;
  }
}
@media screen and (max-width: 1920px) and (min-width: 1680px) {
  .bigSvg {
    width: 1400px;
    margin-top: 50px !important;
    display: none;
  }
}

@media screen and (max-width: 1440px) and (min-width: 0px) {
  .hero_fallingLines__iA0dJ {
    height: 180px;
    margin-top: 244px !important;
  }
}
@media screen and (max-width: 1440px) and (min-width: 0px) {
  .cta_xl__fgT4k {
    margin-top: 0px !important;
    height: 42px !important;
    line-height: 42px !important;
    font-size: 16px !important;
    --padding: 0 30px;
  }
}
@media screen and (max-width: 1440px) and (min-width: 0px) {
  .cta_iconSuffix__SwTwt {
    margin-top: -12px !important;
  }
}
@media screen and (max-width: 1440px) and (min-width: 0px) {
  .hero_logoAnimated {
    margin-top: 100px !important;
  }
}
@media screen and (max-width: 1920px) and (min-width: 1680px) {
  .hero_logoAnimated {
    margin-top: 180px !important;
  }
}

/deep/ .el-dialog {
  border-radius: 15px;
}

.login-content {
  width: 100%;

  .top {
    width: 100%;
    overflow: hidden;
    img {
      width: 280px;
      margin: 0 auto;
    }
    span {
      color: #13171d;
      font-size: 40px;
      display: inline-block;
      line-height: 56px;
      float: left;
      margin-left: 10px;
    }
  }

  .center {
    margin-top: 20px;

    .el-form-item {
      display: block;

      /deep/ .el-form-item__label {
        justify-content: flex-start;
        width: 360px !important;
        display: block;
      }

      /deep/ .el-form-item__content {
        display: block;
        margin-left: 0px !important;
      }
    }

    .line {
      width: 100%;
      float: left;
      text-align: left;

      .nam {
        color: #13171d;
        line-height: 20px;
        width: 72px;
        display: block;
      }

      .border {
        display: block;
        width: 20px;
        height: 2px;
        background: #001d7f;
        margin-left: 16px;
      }

      .login-btn {
        width: 308px;
        height: 36px;
        background: #001d7f;
        border-radius: 5px;
        margin: 0 auto;
        line-height: 36px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
      }

      .line-line {
        padding: 5px 0;

        .color {
          color: red;
          margin-right: 2px;
          margin-top: 4px;
          float: left;
        }

        span {
          font-size: 14px;
        }
      }
    }

    .code {
      position: relative;

      .el-input {
        width: 100% !important;

        /deep/ .el-input__inner {
          width: 200px;
          overflow: hidden;
        }
      }

      .getCode {
        position: absolute;
        border-left: 1px solid #ccc;
        padding-left: 10px;
        color: #d65f4c;
        float: right;
        right: 10px;
        cursor: pointer;
      }
    }

    .login-line {
      text-align: center;

      .el-button {
        width: 100%;
        height: 36px;
        background: #001d7f;
        border-radius: 5px;
        margin: 0 auto;
        line-height: 36px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        border: 1px solid #001d7f;
      }

      .is-disabled {
        opacity: 0.8;
      }
    }

    .phone {
      .el-input {
        width: 300px;
      }
    }

    .pwd {
      .el-input {
        width: 180px;
      }

      .btn {
        width: 100px;
        display: inline-block;
        margin-left: 15px;
        cursor: pointer;
      }
    }

    .checked {
      font-size: 12px;

      .el-checkbox {
        float: left;
      }

      .span {
        display: inline-block;
        line-height: 34px;
        float: left;
        margin-left: 5px;

        .color {
          color: #001d7f;
          cursor: pointer;
        }
      }
    }

    .login-line {
      margin-top: 20px;
    }

    .checkbox {
      .el-checkbox {
        margin-right: 10px;
      }
    }

    .loginInfo {
      margin-top: 10px;
      width: 100%;
      float: left;
    }
  }
}

.login-content2 {
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;

  .network_show {
    width: 100%;
    height: 100%;
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.experience {
  color: #c9cbd1;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
  padding-bottom: 40px;

  span {
    &:nth-child(2) {
      margin-left: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 16px;
    }
  }
}

.application {
  color: #41ae1b;
  margin-top: 10px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 18px;

  img {
    display: inline-block;
    width: 24px;
    margin-top: 8px;
    margin-right: 5px;
    float: left;
  }

  span {
    display: inline-block;
    float: left;
  }
}

.cta_content__zyHoI {
  cursor: pointer;
  font-size: 18px;
}

.cta_cta__pjYag {
  border-radius: 5px;
  height: 50px;
  padding: 0px 25px;
  font-size: 20px;
}

/deep/ .is-checked {
  --el-checkbox-checked-input-border-color: rgb(0, 29, 127);
  --el-checkbox-checked-bg-color: rgb(0, 29, 127);
  --el-radio-input-border: rgb(0, 29, 127);
  --el-radio-input-border-color: rgb(0, 29, 127);

  .el-radio__inner {
    background: rgb(0, 29, 127) !important;
  }

  .el-checkbox__label,
  .el-radio__label {
    color: rgb(0, 29, 127) !important;
  }
}

.image-animation {
  animation: image-pulse 1s ease-in;
}

@keyframes image-pulse {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>
